"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var constants_1 = require("../../../constants");

var utils_1 = require("../../../utils");

var Card_1 = __importDefault(require("../../Card"));

var Detail_1 = __importDefault(require("../../Card/Detail"));

var Header_1 = __importDefault(require("../../Card/Header"));

var Image_1 = __importDefault(require("../../Card/Image"));

var Transition_1 = __importDefault(require("../../Transition"));

var Tile_1 = __importDefault(require("../Tile"));

require("./style.scss");

var key = function key(_a, index) {
  var label = _a.label;
  return index + "-" + label;
};
/**
 * Moment to visualize organizations associated with the `Story`'s subject.
 */


var MembershipMoment = function MembershipMoment(props) {
  var data = props.data;

  var _a = (0, react_1.useState)(''),
      selected = _a[0],
      setSelected = _a[1];

  var handleCloseDialog = function handleCloseDialog() {
    return setSelected('');
  };

  var renderDialog = function renderDialog(item, index) {
    var open = !!selected && selected === key(item, index);
    var description = item.description,
        graphic = item.graphic,
        image = item.image,
        label = item.label,
        logo = item.logo,
        website = item.website;
    var mainImage = image || logo || '';
    var secondaryImage = mainImage === logo || !logo ? graphic.url : logo;
    return react_1.default.createElement(Dialog_1.default, {
      className: "story-membership-dialog",
      open: open,
      TransitionComponent: Transition_1.default,
      keepMounted: true,
      onClose: handleCloseDialog
    }, react_1.default.createElement(Grid_1.default, {
      container: true,
      spacing: 0
    }, react_1.default.createElement(Grid_1.default, {
      className: "story-membership-dialog-left",
      item: true,
      xs: 5
    }, react_1.default.createElement(Image_1.default, {
      alt: label,
      src: mainImage
    })), react_1.default.createElement(Grid_1.default, {
      className: "story-membership-dialog-right",
      item: true,
      xs: 7
    }, react_1.default.createElement(Card_1.default, null, react_1.default.createElement(Image_1.default, {
      alt: label,
      src: secondaryImage
    }), react_1.default.createElement(Header_1.default, {
      text: label
    }), website && react_1.default.createElement("div", {
      className: "membership-dialog-button"
    }, react_1.default.createElement(Button_1.default, {
      href: website,
      style: {
        background: graphic.background_color,
        color: graphic.foreground_color
      },
      target: "_blank",
      variant: "contained"
    }, "Learn More")), description && react_1.default.createElement(Detail_1.default, null, description)))));
  };

  return (// eslint-disable-next-line react/jsx-props-no-spreading
    react_1.default.createElement(Tile_1.default, __assign({}, props), data.map(function (item, index) {
      return react_1.default.createElement("div", {
        className: "story-membership-graphic-container",
        key: key(item, index),
        style: {
          background: (0, utils_1.hexToRgbA)(item.graphic.background_color, 0.2)
        }
      }, react_1.default.createElement("div", {
        className: "story-membership-graphic",
        onClick: function onClick() {
          return setSelected(key(item, index));
        },
        onKeyPress: function onKeyPress() {
          return setSelected(key(item, index));
        },
        role: "button",
        tabIndex: 0
      }, react_1.default.createElement("object", {
        "aria-label": "Graphic Background",
        data: item.graphic.url,
        type: "image/svg+xml"
      })), renderDialog(item, index));
    }))
  );
};

MembershipMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Determines the information to render. */
  data: prop_types_1.default.arrayOf(prop_types_1.default.object),

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: prop_types_1.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: prop_types_1.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** Main heading element of the `Moment` */
  title: prop_types_1.default.node,

  /** The type of `Moment` */
  type: prop_types_1.default.string
};
MembershipMoment.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  type: constants_1.MomentType.Membership
});
exports.default = MembershipMoment;